export const translations = {
  en: {
    chooseLanguage: "Choose your language",
    continue: "Continue",
    heroTag: "Operating Authority. Simplified.",
    heroTitle: "Start your trucking business, right the first time.",
    heroSub: "CarrierLaunch guides you through USDOT, MC Authority, BMC-84/91, insurance, UCR, IFTA, and ELD — step by step, in your language.",
    getStarted: "Get started",
    signIn: "Sign in",
    signOut: "Sign out",
    dashboard: "Dashboard",
    wizard: "Setup Wizard",
    chat: "AI Assistant",
    pricing: "Pricing",
    pickPlan: "Pick a Plan",
    legalName: "Legal Business Name",
    dbaName: "DBA / Trade Name",
    entityType: "Entity Type",
    homeState: "Home State",
    operationState: "State of Operation",
    operationType: "Interstate or Intrastate",
    vehicles: "Vehicle Types",
    licenseClass: "Driver License Class",
    eldCompany: "ELD Company",
    saveContinue: "Save & Continue",
    back: "Back",
    step: "Step",
    of: "of",
    businessInfo: "Business Information",
    operation: "Operation Details",
    equipment: "Equipment & Cargo",
    drivers: "Drivers",
    review: "Review & Launch",
    filings: "FMCSA Filings",
    navHome: "Home", navSetup: "Setup", navDocs: "Docs", navAI: "AI Help", navCommunity: "Community", navPlans: "Plans",
  },
  es: {
    chooseLanguage: "Elige tu idioma",
    continue: "Continuar",
    heroTag: "Autoridad Operativa. Simplificada.",
    heroTitle: "Inicia tu empresa de transporte, bien desde el principio.",
    heroSub: "CarrierLaunch te guía a través de USDOT, MC Authority, BMC-84/91, seguros, UCR, IFTA y ELD — paso a paso, en tu idioma.",
    getStarted: "Comenzar",
    signIn: "Iniciar sesión",
    signOut: "Cerrar sesión",
    dashboard: "Panel",
    wizard: "Asistente",
    chat: "Asistente IA",
    pricing: "Precios",
    pickPlan: "Elige un plan",
    legalName: "Nombre Legal del Negocio",
    dbaName: "DBA / Nombre Comercial",
    entityType: "Tipo de Entidad",
    homeState: "Estado de Origen",
    operationState: "Estado de Operación",
    operationType: "Interestatal o Intraestatal",
    vehicles: "Tipos de Vehículo",
    licenseClass: "Clase de Licencia",
    eldCompany: "Compañía ELD",
    saveContinue: "Guardar y Continuar",
    back: "Atrás",
    step: "Paso",
    of: "de",
    businessInfo: "Información del Negocio",
    operation: "Detalles de Operación",
    equipment: "Equipo y Carga",
    drivers: "Conductores",
    review: "Revisar y Lanzar",
    filings: "Trámites FMCSA",
    navHome: "Inicio", navSetup: "Configurar", navDocs: "Docs", navAI: "Ayuda IA", navCommunity: "Comunidad", navPlans: "Planes",
  },
  fr: {
    chooseLanguage: "Choisissez votre langue",
    continue: "Continuer",
    heroTag: "Autorité d'exploitation. Simplifiée.",
    heroTitle: "Lancez votre entreprise de transport correctement, dès la première fois.",
    heroSub: "CarrierLaunch vous guide à travers USDOT, MC Authority, BMC-84/91, assurance, UCR, IFTA et ELD — étape par étape, dans votre langue.",
    getStarted: "Commencer",
    signIn: "Se connecter",
    signOut: "Se déconnecter",
    dashboard: "Tableau de bord",
    wizard: "Assistant",
    chat: "Assistant IA",
    pricing: "Tarifs",
    pickPlan: "Choisir un forfait",
    legalName: "Nom légal de l'entreprise",
    dbaName: "DBA / Nom commercial",
    entityType: "Type d'entité",
    homeState: "État d'origine",
    operationState: "État d'exploitation",
    operationType: "Inter-États ou Intra-État",
    vehicles: "Types de véhicules",
    licenseClass: "Classe de permis",
    eldCompany: "Société ELD",
    saveContinue: "Enregistrer et continuer",
    back: "Retour",
    step: "Étape",
    of: "de",
    businessInfo: "Informations commerciales",
    operation: "Détails d'exploitation",
    equipment: "Équipement et marchandises",
    drivers: "Chauffeurs",
    review: "Vérifier et lancer",
    filings: "Dépôts FMCSA",
    navHome: "Accueil", navSetup: "Config.", navDocs: "Docs", navAI: "Aide IA", navCommunity: "Communauté", navPlans: "Forfaits",
  },
  pa: {
    chooseLanguage: "ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ",
    continue: "ਜਾਰੀ ਰੱਖੋ",
    heroTag: "ਆਪਰੇਟਿੰਗ ਅਥਾਰਟੀ. ਸਰਲ.",
    heroTitle: "ਆਪਣਾ ਟਰੱਕਿੰਗ ਬਿਜ਼ਨਸ ਪਹਿਲੀ ਵਾਰ ਵਿੱਚ ਹੀ ਸਹੀ ਸ਼ੁਰੂ ਕਰੋ।",
    heroSub: "CarrierLaunch ਤੁਹਾਨੂੰ USDOT, MC Authority, BMC-84/91, ਇੰਸ਼ੋਰੈਂਸ, UCR, IFTA ਅਤੇ ELD ਰਾਹੀਂ ਕਦਮ-ਦਰ-ਕਦਮ, ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਵਿੱਚ ਮਾਰਗਦਰਸ਼ਨ ਕਰਦਾ ਹੈ।",
    getStarted: "ਸ਼ੁਰੂ ਕਰੋ",
    signIn: "ਸਾਈਨ ਇਨ",
    signOut: "ਸਾਈਨ ਆਊਟ",
    dashboard: "ਡੈਸ਼ਬੋਰਡ",
    wizard: "ਵਿਜ਼ਾਰਡ",
    chat: "AI ਸਹਾਇਕ",
    pricing: "ਕੀਮਤ",
    pickPlan: "ਪਲਾਨ ਚੁਣੋ",
    legalName: "ਕਾਨੂੰਨੀ ਬਿਜ਼ਨਸ ਨਾਮ",
    dbaName: "DBA / ਵਪਾਰ ਨਾਮ",
    entityType: "ਐਂਟੀਟੀ ਕਿਸਮ",
    homeState: "ਘਰ ਰਾਜ",
    operationState: "ਸੰਚਾਲਨ ਰਾਜ",
    operationType: "ਇੰਟਰਸਟੇਟ ਜਾਂ ਇੰਟਰਾਸਟੇਟ",
    vehicles: "ਵਾਹਨ ਕਿਸਮਾਂ",
    licenseClass: "ਲਾਇਸੰਸ ਕਲਾਸ",
    eldCompany: "ELD ਕੰਪਨੀ",
    saveContinue: "ਸੇਵ ਕਰੋ ਅਤੇ ਜਾਰੀ ਰੱਖੋ",
    back: "ਵਾਪਸ",
    step: "ਕਦਮ",
    of: "ਦਾ",
    businessInfo: "ਬਿਜ਼ਨਸ ਜਾਣਕਾਰੀ",
    operation: "ਸੰਚਾਲਨ ਵੇਰਵੇ",
    equipment: "ਉਪਕਰਨ ਅਤੇ ਮਾਲ",
    drivers: "ਡਰਾਈਵਰ",
    review: "ਸਮੀਖਿਆ",
    filings: "FMCSA ਫਾਈਲਿੰਗ",
    navHome: "ਹੋਮ", navSetup: "ਸੈੱਟਅੱਪ", navDocs: "ਦਸਤਾਵੇਜ਼", navAI: "AI ਮਦਦ", navCommunity: "ਭਾਈਚਾਰਾ", navPlans: "ਪਲਾਨ",
  },
  ru: {
    chooseLanguage: "Выберите язык",
    continue: "Продолжить",
    heroTag: "Операционная лицензия. Упрощённо.",
    heroTitle: "Запустите грузовой бизнес правильно с первого раза.",
    heroSub: "CarrierLaunch проведёт вас через USDOT, MC Authority, BMC-84/91, страхование, UCR, IFTA и ELD — пошагово, на вашем языке.",
    getStarted: "Начать",
    signIn: "Войти",
    signOut: "Выйти",
    dashboard: "Панель",
    wizard: "Мастер",
    chat: "ИИ-помощник",
    pricing: "Тарифы",
    pickPlan: "Выбрать тариф",
    legalName: "Юридическое название",
    dbaName: "DBA / Торговое имя",
    entityType: "Тип компании",
    homeState: "Домашний штат",
    operationState: "Штат деятельности",
    operationType: "Межштатный или Внутриштатный",
    vehicles: "Типы транспорта",
    licenseClass: "Класс водительских прав",
    eldCompany: "Компания ELD",
    saveContinue: "Сохранить и продолжить",
    back: "Назад",
    step: "Шаг",
    of: "из",
    businessInfo: "Информация о бизнесе",
    operation: "Детали деятельности",
    equipment: "Оборудование и груз",
    drivers: "Водители",
    review: "Проверка",
    filings: "Документы FMCSA",
    navHome: "Главная", navSetup: "Настройка", navDocs: "Документы", navAI: "ИИ", navCommunity: "Сообщество", navPlans: "Тарифы",
  },
  zh: {
    chooseLanguage: "选择您的语言",
    continue: "继续",
    heroTag: "运营授权，简化流程。",
    heroTitle: "一次性正确启动您的货运业务。",
    heroSub: "CarrierLaunch 一步步指导您完成 USDOT、MC Authority、BMC-84/91、保险、UCR、IFTA 和 ELD — 使用您的母语。",
    getStarted: "开始",
    signIn: "登录",
    signOut: "退出",
    dashboard: "仪表板",
    wizard: "向导",
    chat: "AI 助手",
    pricing: "定价",
    pickPlan: "选择套餐",
    legalName: "法定公司名称",
    dbaName: "DBA / 商业名称",
    entityType: "实体类型",
    homeState: "注册州",
    operationState: "运营州",
    operationType: "州际或州内",
    vehicles: "车辆类型",
    licenseClass: "驾照等级",
    eldCompany: "ELD 公司",
    saveContinue: "保存并继续",
    back: "返回",
    step: "步骤",
    of: "/",
    businessInfo: "商业信息",
    operation: "运营详情",
    equipment: "设备与货物",
    drivers: "司机",
    review: "审核",
    filings: "FMCSA 申报",
    navHome: "首页", navSetup: "设置", navDocs: "文件", navAI: "AI 帮助", navCommunity: "社区", navPlans: "套餐",
  },
  hi: {
    chooseLanguage: "अपनी भाषा चुनें",
    continue: "जारी रखें",
    heroTag: "ऑपरेटिंग अथॉरिटी। आसान।",
    heroTitle: "अपना ट्रकिंग व्यवसाय पहली बार में ही सही तरीके से शुरू करें।",
    heroSub: "CarrierLaunch आपको USDOT, MC Authority, BMC-84/91, बीमा, UCR, IFTA और ELD के हर कदम पर आपकी भाषा में मार्गदर्शन देता है।",
    getStarted: "शुरू करें",
    signIn: "साइन इन",
    signOut: "लॉग आउट",
    dashboard: "डैशबोर्ड",
    wizard: "सेटअप विज़ार्ड",
    chat: "AI सहायक",
    pricing: "कीमतें",
    pickPlan: "प्लान चुनें",
    legalName: "कानूनी व्यवसाय नाम",
    dbaName: "DBA / व्यापारिक नाम",
    entityType: "इकाई प्रकार",
    homeState: "गृह राज्य",
    operationState: "संचालन राज्य",
    operationType: "अंतरराज्यीय या राज्य के भीतर",
    vehicles: "वाहन प्रकार",
    licenseClass: "ड्राइवर लाइसेंस श्रेणी",
    eldCompany: "ELD कंपनी",
    saveContinue: "सहेजें और जारी रखें",
    back: "वापस",
    step: "चरण",
    of: "/",
    businessInfo: "व्यवसाय जानकारी",
    operation: "संचालन विवरण",
    equipment: "उपकरण और माल",
    drivers: "ड्राइवर",
    review: "समीक्षा और लॉन्च",
    filings: "FMCSA फाइलिंग",
    navHome: "होम", navSetup: "सेटअप", navDocs: "दस्तावेज़", navAI: "AI मदद", navCommunity: "समुदाय", navPlans: "प्लान",
  },
};

export const languageOptions = [
  { code: "en", label: "English", native: "English" },
  { code: "es", label: "Español", native: "Español" },
  { code: "fr", label: "Français", native: "Français" },
  { code: "pa", label: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { code: "ru", label: "Russian", native: "Русский" },
  { code: "zh", label: "Chinese", native: "中文" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
];
